var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-action-cell",class:_vm.grid},[_c('a',{attrs:{"href":_vm.url,"target":_vm.target}},[_c('div',{staticClass:"table-action-cell__icon-wrapper"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"table-action-cell__label"},[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }